import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import * as qs from 'qs';
import { router } from '@/router';
import * as _ from 'lodash';

const dateFormatRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
function jsonDateParser(key: string, value: string) {
	if (typeof value === 'string' && dateFormatRegex.test(value)) {
		return new Date(value);
	}

	return value;
}

function parseJson(data: string) {
	if (!data) return data;

	try {
		const parsedJson = JSON.parse(data, jsonDateParser);
		return parsedJson;
	} catch (error) {
		throw Error(`[axios] Error parsing response JSON data - ${JSON.stringify(error)}`);
	}
}

function globalAxiosResponseFulfilledHandler(response: AxiosResponse) {
	const responseData = response.data;
	return responseData;
}

function globalAxiosResponseRejectedHandler(error: unknown) {
	if (error instanceof AxiosError && _.get(error, 'response.status') === 401) {
		const currentRoute = router.currentRoute.path;
		const loginRoute = '/login';
		const requestUrl = _.get(error, 'response.config.url');
		if (currentRoute !== loginRoute && requestUrl !== '/auth/login') {
			console.log("Failed to load resource via axios, redirecting to '/login'.", error);
			router.push(loginRoute);
			return;
		}
	}
	throw error;
}

export let api: AxiosInstance;

export function initializeApi() {
	const options: AxiosRequestConfig = {
		baseURL: window.__APP_CONFIG__.BACKEND_URL,
		transformResponse: [parseJson],
		paramsSerializer: {
			serialize: (params: any) => qs.stringify(params, { encode: true, arrayFormat: 'brackets' }),
		},
		withCredentials: true,
	};
	api = axios.create(options);
	api.interceptors.response.use(globalAxiosResponseFulfilledHandler, globalAxiosResponseRejectedHandler);
}
